<template>
  <div id="marquee">
    <swiper
      v-show="!hide && marquees.length != 0"
      class="swiper"
      :options="swiperOption"
    >
      <swiper-slide
        v-for="(slide,slide_index) in marquees"
        :key="slide_index"
        class="swiper_slide"
        :style="`background-color:${slide.BgColor}`"
      >
        <div
          class="slide"
          :style="`color:${slide.TextColor}`"
          @click="goto(slide.Url, slide.Title)"
        >
          {{ slide.Title }}   <i
            class="hide el-icon-close"
            :style="`color:${slide.TextColor}`"
            aria-hidden="true"
            @click.stop="hide = true"
          />
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { googleFormTransform } from '@/js/utils'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
export default {
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      hide: false,
      color: '',
      backgroundColor: '',
      marquees: [],
      swiperOption: {
        autoplay: {
          delay: 5000
        },
        direction: 'vertical',
        height: 46
      }
    }
  },
  computed: {
    isVisible () {
      return !this.hide && this.marquees.length !== 0
    }
  },
  watch: {
    isVisible: {
      immediate: true,
      handler (val) {
        this.$emit('visibility-change', val)
      }
    }
  },
  mounted () {
    vuecp.marquee = this
    this.getData()
  },
  methods: {
    async getData () {
      const res = await this.$getAPI(`${process.env.VUE_APP_HOUSEKEEPER_CORE_URL}/api/v1/Marquee`)
      this.marquees = res.Marquees.map(el => {
        const processedUrl = googleFormTransform.fetchURL(el.Url)
        return {
          ...el,
          Url: processedUrl
        }
      })
    },
    goto (url, title) {
      this.$sendGAEvent('跑馬燈點擊數', {
        value: `click_${title}_${url}`
      })
      window.open(url, '_blank')
    }
  }
}
</script>

<style lang="sass" scoped>
$marquee_height: 46px

#marquee
  width: 100%
  box-shadow: 0 8px 15px -8px $bgDark1
  text-align: center
  line-height: $marquee_height
  z-index: 20

  ::v-deep .swiper-container
    height: $marquee_height
  .hide
    float: right
    margin-left: auto
    position: absolute
    right: 16px
    top: 10px
    font-size: 24px
  .swiper
    position: relative
  .swiper-wrapper
    padding-top: 10px
    padding-bottom: 8px
  .swiper_slide
    cursor: pointer
    .slide
      font-size: 20px
      cursor: pointer
      width: 80%
      margin: auto
      &:hover
        opacity: 0.8
        text-decoration: underline
  .close
    position: absolute
    top: 0
    right: 2%
    color: #fff
    zoom: 1.3
    cursor: pointer
    z-index: 2
</style>
